export const blockIconsMapsLocalPoliceNew = (
	<span className='material-symbols-outlined'>local_police</span>
);
